import React from "react";

const categories = [
  "Tous",
  "Histoires de Makers",
  "Innovation & Éducation",
  "Projets & Tutoriaux",
  "Vie de la Communauté",
  "NextMaker Insights",
];

const BlogCategories = ({ selected, setSelected }) => (
  <div className="flex flex-wrap justify-center gap-3 py-6">
    {categories.map((cat, i) => (
      <button
        key={i}
        className={`px-5 py-2 rounded-full border-2 font-medium transition ${
          selected === cat
            ? "bg-blue-1 text-white border-blue-1"
            : "bg-white text-dark-1 border-light-2 hover:bg-light-5"
        }`}
        onClick={() => setSelected(cat)}
      >
        {cat}
      </button>
    ))}
  </div>
);

export default BlogCategories;
